import { render, staticRenderFns } from "./WorkflowCard.vue?vue&type=template&id=319f12df&"
import script from "./WorkflowCard.vue?vue&type=script&lang=ts&"
export * from "./WorkflowCard.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowCard.vue?vue&type=style&index=0&id=319f12df&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports